<template>
  <div class="body">
    <div class="remove" @click="removeClick"></div>
    <div class="dialogWarp">
      <div class="warp">
        <van-image
          :src="require('../../../../../../public/image/13/01/2.png')"
        ></van-image>
        <van-field v-model="phone" placeholder="輸入手機號">
          <template #label>
            <van-dropdown-menu :overlay="false" active-color="rgb(114, 43, 17)">
              <van-dropdown-item v-model="areatype" :options="option" />
            </van-dropdown-menu>
          </template>
        </van-field>
        <div class="checked">
          <van-checkbox icon-size="12px" v-model="checked" shape="square">
            <template #icon="props">
              <img
                v-if="!props.checked"
                class="img-icon1"
                :src="require('../../../../../../public/image/13/01/4.png')"
              />
              <div class="checkImage" v-else>
                <img
                  class="img-icon"
                  :src="require('../../../../../../public/image/13/01/4.png')"
                />
                <img
                  class="img-icon"
                  :src="require('../../../../../../public/image/13/01/5.png')"
                />
              </div>
            </template>
            <van-image
              :src="require('../../../../../../public/image/13/01/3.png')"
            >
            </van-image>
          </van-checkbox>
        </div>
        <div @click="Purchase" class="buttonWarp">
          <van-image
            :src="require('../../../../../../public/image/13/01/6.png')"
          ></van-image>
          <van-image
            :src="require('../../../../../../public/image/13/01/8.png')"
          ></van-image>
        </div>
        <div>
          <van-image
            :src="require('../../../../../../public/image/13/01/7.png')"
          ></van-image>
        </div>
        <div class="jdImage">
          <van-image
            :src="require('../../../../../../public/image/13/01/9.png')"
          ></van-image>
        </div>
        <div class="timeImage">
          <van-count-down
            millisecond
            ref="countDown"
            @finish="finish"
            :time="time"
            format="HH:mm:ss:SS"
          >
            <template #default="timeData">
              <div>
                <div class="timeImageWarp">
                  <span>{{ '0' + timeData.minutes }}</span>
                  <span>{{
                    timeData.seconds < 10
                      ? '0' + String(timeData.seconds)
                      : timeData.seconds
                  }}</span>
                  <span>{{ (timeData.milliseconds / 10).toFixed(0) }}</span>
                </div>
              </div>
            </template>
          </van-count-down>
        </div>
        <div class="footerImage">
          <van-image
            :src="require('../../../../../../public/image/13/01/11.png')"
          ></van-image>
        </div>
      </div>
    </div>
    <SimpleDialog
      :backgroundImage="require('../../../../../../public/image/12/3/1.png')"
      :removeImage="require('../../../../../../public/image/12/3/3.png')"
      :textImage="require('../../../../../../public/image/12/3/2.png')"
      :visible.sync="showEasy"
      @changeVisible="showEasy = !showEasy"
    />
  </div>
</template>

<script>
import getData from '../../../../../../utils/request/request'
import SimpleDialog from '../../simpleDialog/index.vue'
import getButton from '../../../../../../utils/getButton'

import { Toast } from 'vant'
export default {
  components: {
    SimpleDialog
  },
  props: {
    visible: Boolean,
    isActivity: Boolean
  },
  name: 'page1',
  created() {
    this.$emit(
      'changeBackgroundImage',
      require('../../../../../../public/image/13/01/1.png')
    )
  },
  data() {
    return {
      showEasy: false,
      option: [
        { text: '台灣+886', value: 0 },
        { text: '香港+852', value: 1 },
        { text: '澳门+853', value: 2 }
        // { text: '新加坡+65', value: 3 },
        // { text: '馬來西亞+60', value: 4 }
      ],
      time: 30 * 1000,
      areatype: 0,
      phone: '',
      checked: true
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.$refs.countDown.reset()
        this.$refs.countDown.start()
      }
    }
  },
  methods: {
    async Purchase() {
      if (this.isActivity) {
        getButton('預約頁-手機預約彈窗-立即預約按鈕')
      } else {
        getButton('版頭-手機預約彈窗-立即預約按鈕')
      }
      if (this.checked) {
        let Api = {
          url: '/api/phone_yuyue',
          type: 'post'
        }
        let form = {
          utm: this.$route.query.utm_source ? this.$route.query.utm_source : '',
          phone: this.phone,
          areatype: this.areatype
        }
        let res = await getData(this.$http(Api, form))
        if (res.code === 1) {
          Toast(res.msg)
          this.$emit('changePage', 2)
          this.$store.commit('changePhone', res.phone)
          this.$emit('getStatus')
          this.$emit('setPhone', this.phone)
          this.$store.commit('changeTel', {
            tel: this.phone,
            areatype: this.areatype
          })
          this.$emit('setAreatype', this.areatype)
          fbq('track', 'Purchase')
          ttq.track('AddToWishlist')
        } else {
          switch (res.msg) {
            case '您輸入的手機號格式錯誤':
              this.showEasy = true
              break
            default:
              Toast(res.msg)
              break
          }
        }
      } else {
        Toast.fail('請勾選同意個人資料')
      }
    },
    finish() {
      this.$refs.countDown.reset()
      this.$refs.countDown.start()
    },
    removeClick() {
      this.$emit('removeClick', false)
    }
  }
}
</script>

<style lang="scss" scoped>
@keyframes heartbeat {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
/deep/ .van-dropdown-menu__bar {
  height: 22px;
  box-shadow: none;
  color: rgb(114, 43, 17);
  text-align: center;
  font-weight: 550;
}
/deep/ .van-dropdown-menu__title {
  color: rgb(114, 43, 17);
}
/deep/ .van-dropdown-menu__title::after {
  border-color: transparent transparent rgb(114, 43, 17) rgb(114, 43, 17);
}
/deep/ .van-dropdown-item {
  top: 288px !important;
  padding: 0px 20px;
}
// /deep/ .van-overlay {
//   width: 300px;
//   margin-left: 10px;
//   display: none;
// }
/deep/ .van-cell::after {
  border-bottom: 2px solid #fff;
}
/deep/ .van-dropdown-item__content {
  width: 280px;
  //   margin-left: 20px;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 0px;
  border-radius: 10px;
  border: 2px solid rgb(114, 43, 17);
  box-sizing: border-box;
}
/deep/ .van-dropdown-item__option--active {
  font-weight: 550;
}
/deep/ .van-field__value {
  border-left: 1px solid rgb(114, 43, 17);
}
/deep/ .van-field__label {
  width: 120px;
}
/deep/ .van-field {
  margin-top: 10px;
  width: 100%;
  border-radius: 2rem;
  border: 2px solid rgb(114, 43, 17);
  color: rgb(114, 43, 17);
  padding: 5px 0px;
  .van-field__control {
    padding: 0px 16px;
    color: rgb(114, 43, 17);
  }
  /deep/ .van-field__title {
    margin-right: 0;
    padding-right: 12px;
  }

  .van-field__control::placeholder {
    text-align: center;
    color: rgb(114, 43, 17);
    font-size: 1rem;
    font-weight: 550;
  }
}
.body {
  width: 100%;
  height: 100%;
  position: relative;
  padding: 10px;
  box-sizing: border-box;
  .remove {
    width: 20px;
    height: 30px;
    position: absolute;
    top: 178px;
    right: 34px;
    z-index: 1000;
  }
  .dialogWarp {
    margin: 20px;
    position: relative;
    width: calc(100% - 40px);
    height: 100%;
    box-sizing: border-box;
    .warp {
      position: absolute;
      top: 185px;
      left: 0px;
      padding: 0px 10px;
    }
    /deep/ .van-checkbox__icon {
      background: #fff;
      border-radius: 0.2rem;
      .van-icon {
        border: 0px solid #fff;
      }
    }
    /deep/ .van-checkbox__label {
      margin-left: 3px;
    }
    .checked {
      margin-top: 10px;
      .img-icon1 {
        height: 14px;
        position: relative;
      }
      /deep/ .van-checkbox__icon {
        width: 14px;
        height: 14px;
      }
      .checkImage {
        position: relative;
        height: 14px;
        width: 14px;
        img {
          position: absolute;
          top: 0;
          left: 0;
        }
        img:nth-child(1) {
          width: 12px;
          height: 12px;
        }
      }
      /deep/ .van-checkbox__label {
        line-height: 12px;
        display: inline-block;
        .van-image {
          margin-left: 5px;
          width: 190px;
          height: 12px;
        }
      }
      /deep/ .van-icon-success {
        border-radius: 0.2rem;
      }
    }
    .buttonWarp {
      animation: heartbeat 1s ease infinite;
      padding: 10px;
      position: relative;
      /deep/ .van-image:nth-child(2) {
        width: 30px;
        position: absolute;
        bottom: 0%;
        right: 0;
      }
    }
    .footerImage {
      width: 60%;
      margin: 0 auto;
    }
    .timeImageWarp {
      margin: 5px 10px;
      width: calc(100% - 20px);
      height: 40px;
      background: url(../../../../../../public/image/13/01/10.png) no-repeat;
      background-size: 100% 100%;
      display: flex;
      justify-content: space-around;
      span {
        width: 65px;
        display: block;
        line-height: 40px;
        font-size: 20px;
        color: rgb(114, 43, 17);
      }
      span:nth-child(1) {
        text-align: right;
      }
      span:nth-child(2) {
        text-align: center;
      }
      span:nth-child(3) {
        text-align: left;
      }
    }
  }
}
.removeImage {
  position: absolute;
  width: 20px;
  top: 15px;
  right: 15px;
  z-index: 1000;
}
</style>


// WEBPACK FOOTER //
// src/route/src/prereg/components/faceDialog/page1/index.vue